<template>
  <div>
    <menu-bar active="post"></menu-bar>
    <div class="large-8 columns content__column">
        <h2>Skriv en melding</h2>

        <div class="row form">
          <div class="form__field small-12 columns">
            <label class="form__label">
              Velg en tittel til meldingen din <span class="form__required">*</span>
              <input type="text" name="title" maxlength="255" required autofocus v-model="message.title" v-validate="'required'" data-vv-as="Tittel">
              <span v-show="errors.has('title')" class="form__field__error">{{ errors.first('title') }}</span>
            </label>
          </div>
          <div class="form__field small-12 columns">
            <label class="form__label">
                Skriv inn meldingen din<span class="form__required">*</span>
              <textarea name="body" rows="10" required v-model="message.body" v-validate="'required'" data-vv-as="Melding"></textarea>
              <span v-show="errors.has('body')" class="form__field__error">{{ errors.first('body') }}</span>
            </label>
          </div>
          <div class="form__submit small-12 large-7 columns">
              <button @click.prevent="post" class="button form__submit__button">Send</button>
          </div>
        </div>
        <hr>
        <br>
        <messages></messages>
    </div>
  </div>
</template>

<script>
  import MenuBar from './Menu.vue';
  import Messages from './Messages.vue';

  export default {
    data(){
      return {
        message : {
          title:'',
          body:''
        }
      }
    },
    components: {
        MenuBar,
        Messages
    },
    methods: {
        post() {
            var _this = this;
            this.$validator.validateAll().then(isValid => {
                if(isValid) {

                    // post
                    this.$http({ method: 'post',url: '/messages', data : this.message })
                    // success
                        .then(function (response) {
                            if(response && response.data) {
                            // (response.data);
                            _this.$router.push('/');
                            }
                        })
                        // failed
                        .catch(function (error) {
                            // console.log(error.response);
                            if(error.response && error.response.data) {
                                // var data = error.response.data;
                                // console.log(data);
                                //_this.postErrors = data;
                            }
                        });
                }
            });
        }
    }
  }
</script>
<style language="scss">

</style>



// WEBPACK FOOTER //
// src/components/Post.vue